import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-dataonedrive',
  templateUrl: './page-dataonedrive.component.html',
  styleUrls: ['./page-dataonedrive.component.css']
})
export class PageDataonedriveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
